// extracted by mini-css-extract-plugin
export default {"container":"Isa-z","tab":"Jsa-z","selected":"Ksa-z"};